import Button from '@doordash/component-button'
import { Text, Inset, Stack } from '@doordash/design-language'
import * as React from 'react'
import HelpArticleButton from '../../atoms/help-article-button'
import OrientationVideo from '../../atoms/orientation-video'
import { HelpContainer, VideoSpacer } from './styles'

import t from './strings'

const HELP_BASEURL = 'https://help.doordash.com/dashers/s/'
const InstantDashHelp = () => (
  <Inset>
    <Stack>
      <Text styles={Text.Styles.Caps16}>{t.howToDash()}</Text>
    </Stack>
    <Stack size={Stack.Sizes.Large}>
      <OrientationVideo />
    </Stack>
    <VideoSpacer />
    <HelpContainer>
      <Text styles={Text.Styles.Caps16}>{t.helpArticles()}</Text>
      <Button
        tag="a"
        isInline
        type={Button.Types.FlatPrimary}
        padding={Button.Padding.None}
        href={HELP_BASEURL}
      >
        {t.seeAll()}
      </Button>
    </HelpContainer>
    <HelpArticleButton href={`${HELP_BASEURL}article/Dasher-App-Overview`}>
      {t.articleHowToDash()}
    </HelpArticleButton>
    <HelpArticleButton href={`${HELP_BASEURL}article/How-to-schedule-a-dash`}>
      {t.articleScheduling()}
    </HelpArticleButton>
    <HelpArticleButton
      // tslint:disable-next-line:max-line-length
      href={`${HELP_BASEURL}article/How-do-I-update-my-bank-account-information`}
    >
      {t.articleDirectDeposit()}
    </HelpArticleButton>
  </Inset>
)

export default InstantDashHelp
